import { DFDHeaders } from '@mhp/general-interface';

export { DFDHeaders } from '@mhp/general-interface';
export type Mutable<T> = { -readonly [P in keyof T]: T[P] };

export interface JWTTokenPayload {
  sub: string; // consumerId
  exp: number;
  iss: string; // PREREG_JWT_ISSUER
  personId: string;
  dfdEventId: string;
  scope: {
    clinicalEvents?: {
      clinicalEventId: string;
    };
  };
}

export class DFDRequestHeaders {
  [DFDHeaders.apiKey]?: string;
  [DFDHeaders.authorization]?: string;
  [DFDHeaders.cacheControl]?: string;
  [DFDHeaders.mhpCacheControl]?: string;
  [DFDHeaders.clinicalEventId]?: string;
  [DFDHeaders.consumerId]?: string;
  [DFDHeaders.contentId]?: string;
  [DFDHeaders.dfdEventId]?: string;
  [DFDHeaders.eventIds]?: string;
  [DFDHeaders.encounterId]?: string;
  [DFDHeaders.kongApiKey]?: string;
  [DFDHeaders.mobileDeviceId]?: string;
  [DFDHeaders.patientId]?: string;
  [DFDHeaders.requestId]?: string;
  [DFDHeaders.webClientId]?: string;
  [DFDHeaders.mhpAdapter]?: string;
  [DFDHeaders.filterSource]?: string;
  [DFDHeaders.resourceId]?: string;
}
